import { NavLink } from 'react-router-dom';
import { Tooltip, TooltipContent, TooltipTrigger } from '../ui/tooltip';
import { cn } from '../../lib/utils';

/* Active icon + label are gold; inactive stays neutral to keep the rail calm. */

function linkClasses(isActive) {
  return cn(
    'group flex items-center gap-3 px-3 py-2.5 rounded text-sm transition-all relative',
    isActive
      ? 'text-gold-700'
      : 'text-muted-foreground hover:bg-foreground/5 hover:text-foreground',
  );
}

export function SidebarNavItem({ item, active, collapsed }) {
  const Icon = item.icon;

  const link = (
    <NavLink
      to={item.to}
      end={item.exact}
      className={() => linkClasses(active)}
      data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
    >
      {/* Active item: 1px gold left rule + gold text (spec §4) */}
      <span
        aria-hidden
        className={cn(
          'absolute left-0 top-1.5 bottom-1.5 w-px transition-opacity',
          active ? 'bg-gold opacity-100' : 'opacity-0',
        )}
      />
      <Icon className={cn(
        'w-5 h-5 shrink-0 transition-colors',
        active ? 'text-gold-700' : 'text-muted-foreground group-hover:text-foreground',
      )} />
      {!collapsed && <span className="truncate">{item.label}</span>}
    </NavLink>
  );

  if (!collapsed) return link;
  return (
    <Tooltip>
      <TooltipTrigger asChild>{link}</TooltipTrigger>
      <TooltipContent side="right">{item.label}</TooltipContent>
    </Tooltip>
  );
}
